import type { MailboxInfo } from "owa-client-types";
import isCopilotFeatureEnabled from "owa-copilot-settings-utils/lib/utils/isCopilotFeatureEnabled";
import isSmimeEnabledInViewState from "owa-smime/lib/utils/isSmimeEnabledInViewState";
import getApplicationSettings from "owa-application-settings/lib/selectors/getApplicationSettings";

// Structural subset of ComposeViewState — importing the type from owa-mail-compose-store
// would form a project-reference cycle through owa-copilot-elaborate.
export interface SuggestedDraftsComposeView {
    mailboxInfo: MailboxInfo;
    bodyType: string;
    copilotViewState: {
        copilotComponentActive?: boolean;
        copilotInsertTimestamp?: number | null;
        draftOriginInfo?: {
            kind: string;
        };
    };
    smimeViewState?: Parameters<typeof isSmimeEnabledInViewState>[0];
    protectionViewState?: {
        IRMData?: {
            RmsTemplateId?: string;
        } | null;
        clpViewState?: {
            selectedCLPLabel?: {
                isEncryptingLabel?: boolean;
            } | null;
        } | null;
    } | null;
}

export function shouldShowSuggestedDrafts(viewState: SuggestedDraftsComposeView): boolean {
    return (isCopilotFeatureEnabled("SuggestedDrafts", viewState.mailboxInfo, getApplicationSettings("Copilot", viewState.mailboxInfo)
        .enableMultiLanguage /* skipLanguageCheck */) === true &&
        viewState.bodyType == "HTML" &&
        !viewState.copilotViewState.draftOriginInfo &&
        !viewState.copilotViewState.copilotComponentActive &&
        !viewState.copilotViewState.copilotInsertTimestamp &&
        !isSmimeEnabledInViewState(viewState.smimeViewState) &&
        !viewState.protectionViewState?.IRMData?.RmsTemplateId &&
        !viewState.protectionViewState?.clpViewState?.selectedCLPLabel?.isEncryptingLabel);
}
